import { Helmet } from "react-helmet-async";

const SITE_NAME = "PublicBeachAccess.com";
const BASE_URL = "https://publicbeachaccess.com";
const DEFAULT_IMAGE = "https://publicbeachaccess.com/images/hero/beach-default.jpg";

const SeoHead = ({ title, description, path = "", image = DEFAULT_IMAGE, type = "website" }) => {
  // Avoid double-appending site name if title already contains it
  const hasSiteName = title && title.includes(SITE_NAME);
  const fullTitle = title
    ? (hasSiteName ? title : `${title} | ${SITE_NAME}`)
    : `${SITE_NAME} | Find Public Beach Access Points`;
  const canonicalUrl = `${BASE_URL}${path}`;
  // Ensure image URLs are absolute for OG/Twitter
  const absoluteImage = image && image.startsWith('/') ? `${BASE_URL}${image}` : (image || DEFAULT_IMAGE);

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="robots" content="index, follow" />
      <link rel="canonical" href={canonicalUrl} />

      {/* Open Graph */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:image" content={absoluteImage} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={SITE_NAME} />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
};

export default SeoHead;
